import ClientDialog from './ClientDialog';

export default ClientDialog;
